export default "__VITE_PUBLIC_ASSET__071c3e47__"